export const texts = {
  defaultTitle: 'Cliente não encontrado',
  defaultDescriptionBase:
    'Ocorreu um erro ao carregar a tabela.\nPor favor, tente novamente mais tarde ou\nverifique sua conexão com a internet.',
  defaultDescriptionSm:
    'Ocorreu um erro ao carregar a tabela.\nPor favor, tente novamente mais tarde ou verifique sua conexão com a internet.',
  withAdvisorTitle: 'Este parceiro não possui clientes.',
  withAdvisorDescriptionBase: 'O parceiro ainda não possui clientes para visualização de detalhes.',
  withAdvisorDescriptionSm: 'O parceiro ainda não possui clientes para visualização de detalhes.',
};
